<template>
    <div>
        <div class="max-w-7xl mx-auto py-10 sm:px-6 lg:px-8">
            <form @submit.prevent="form.post(action)">
                <div class="px-4 py-5 bg-white sm:p-6 shadow-xl rounded-tl-md rounded-tr-md">
                    <div>
                        <jet-label for="name" value="Name"/>
                        <jet-input id="name" class="mt-1 block w-full" type="text" v-model="form.name"/>
                        <div v-if="form.errors.name" class="mt-2 text-sm text-red-600">{{ form.errors.name }}</div>
                    </div>

                    <div class="mt-3">
                        <jet-label for="email" value="Email"/>
                        <jet-input id="email" class="mt-1 block w-full" type="email" name="email" v-model="form.email"/>
                        <div v-if="form.errors.email" class="mt-2 text-sm text-red-600">{{ form.errors.email }}</div>
                    </div>

                    <div class="mt-3">
                        <jet-label for="password" value="Password"/>
                        <jet-input id="password" class="mt-1 block w-full" type="password" name="password" v-model="form.password" autocomplete="off"/>
                        <div v-if="form.errors.password" class="mt-2 text-sm text-red-600">{{ form.errors.password }}</div>
                    </div>

                    <div class="mt-3">
                        <jet-label for="partner_id" value="Partner"/>
                        <select v-model="form.partner_id" class="border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm mt-1 block w-full">
                            <option :value="null">None</option>
                            <option v-for="partner in partners" :value="partner.id">{{ partner.name }}</option>
                        </select>
                        <div class="mt-1 text-xs text-gray-400">Only set if this user belongs to a partner</div>
                        <div v-if="form.errors.partner_id" class="mt-2 text-sm text-red-600">{{ form.errors.partner_id }}</div>
                    </div>

                    <div class="mt-3">
                        <h3 class="block font-medium text-sm text-gray-700">Roles</h3>
                        <div v-for="role in roles">
                            <label>
                                <input v-model="form.roles" class="mr-1" type="checkbox" :value="role.id">
                                {{ role.label ?? role.name }}
                            </label>
                        </div>
                        <div v-if="form.errors.roles" class="mt-2 text-sm text-red-600">{{ form.errors.roles }}</div>
                    </div>
                </div>

                <div class="flex items-center justify-end px-4 py-3 bg-gray-50 text-right sm:px-6 shadow-xl sm:rounded-bl-md sm:rounded-br-md">
                    <inertia-link
                        class="rounded-md border border-transparent bg-yellow-400 hover:bg-yellow-300 transition inline-flex items-center px-4 py-2 mr-2 text-xs text-white uppercase tracking-widest font-semibold"
                        :href="route('users.index')">
                        Cancel
                    </inertia-link>
                    <jet-button :disabled="form.processing">{{ button }}</jet-button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
    import AppLayout from '@/Layouts/AppLayout';
    import {useForm} from '@inertiajs/inertia-vue3';
    import JetButton from '@/Jetstream/Button';
    import JetInput from '@/Jetstream/Input';
    import JetLabel from '@/Jetstream/Label';

    export default {
        props: [
            'user',
            'partners',
            'roles',
            'action',
            'method',
            'button',
        ],

        components: {
            AppLayout,
            JetButton,
            JetInput,
            JetLabel,
        },

        setup(props) {
            const form = useForm({
                _method: props.method || 'PUT',
                name: props.user?.name || null,
                email: props.user?.email || null,
                password: null,
                partner_id: props.user?.partner_id || null,
                roles: props.user?.roles || [],
            });

            return {form}
        },
    }
</script>
